// ── A menü és a fejléc színe: sötét / világos (2026-10-16) ───────────────────────────────────────
// CSAK a SULINFORM Fókuszában (a user: „klasszikus módban nincs sötét/világos, csak fókuszban”), és
// CSAK a keretre – a bal menüre, a felső Fókusz-sávra és az admin fejlécére; a tartalom mindig
// világos (a user: „a content mindig maradjon világos, mert nem néz ki jól sötétben”).
// Sötét = a Fókusz alap-kinézete; Világos = fehér menü és sáv (body.sf-keret-vilagos, global.scss);
// Rendszer = a gép beállítása szerint, változáskor is – ez az alapérték. Böngészőnként (localStorage). Az
// app.component kapcsolja a SULINFORM Fókusz állapota szerint, a Fókusz-sáv választója állítja.

export type Szinmod = 'vilagos' | 'sotet' | 'rendszer';

const KULCS = 'sulinform-szinmod';
let aktiv = false;
let vilagos = false;
let mq: MediaQueryList | null = null;

export function szinmod(): Szinmod {
  try {
    const m = localStorage.getItem(KULCS);
    return m === 'vilagos' || m === 'sotet' ? m : 'rendszer';   // alapból a rendszer szerint (a user kérése)
  } catch { return 'rendszer'; }
}

function alkalmaz() {
  const m = szinmod();
  vilagos = aktiv && (m === 'vilagos' || (m === 'rendszer' && !mq?.matches));
  document.body.classList.toggle('sf-keret-vilagos', vilagos);
}

/** Világos-e most a keret (a menü és a fejléc komponensei ehhez igazodnak). */
export function keretVilagos(): boolean { return vilagos; }

/** A SULINFORM Fókusza be- vagy kikapcsolt (app.component › fokusz). */
export function szinmodAktiv(be: boolean) {
  aktiv = be;
  if (!mq) {
    try {
      mq = window.matchMedia('(prefers-color-scheme: dark)');
      mq.addEventListener('change', alkalmaz);
    } catch { mq = null; }
  }
  alkalmaz();
}

/** A választó (Fókusz-sáv) új értéke. */
export function szinmodBeallit(m: Szinmod) {
  try { localStorage.setItem(KULCS, m); } catch { /* privát ablak: csak most él */ }
  alkalmaz();
}
